import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: #F9F9F9;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

export const Title = styled.div`
  color: rgba(0,0,0,0.7);
  font-family: inherit;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  line-height: 1.1;
`;

export const Text = styled.div`
  color: ${(props) => props.em ? 'rgba(0,0,0,0.7)' : 'rgba(0,0,0,0.6)'};
  font-weight: ${(props) => props.em ? 'normal' : '600'};
  font-family: inherit;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  font-weight: normal;
`;

export const Divider = styled.div`
  height: 20px;
`;
